import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { Package } from "lucide-react";

export default function Orders() {
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    api.get("/orders/my").then((r) => setOrders(r.data || [])).catch(() => {});
  }, []);

  return (
    <div data-testid="orders-page" className="pt-32 pb-20 px-4 sm:px-8 md:px-12 max-w-5xl mx-auto">
      <h1 className="font-display font-black text-4xl sm:text-5xl text-white tracking-tighter flex items-center gap-3">
        <Package className="w-8 h-8 text-tv-accent" /> Your orders
      </h1>

      {orders.length === 0 ? (
        <div data-testid="orders-empty" className="mt-10 text-center text-white/60">
          No orders yet. <Link to="/shop" className="text-tv-accent">Start shopping →</Link>
        </div>
      ) : (
        <div className="space-y-3 mt-6" data-testid="orders-list">
          {orders.map((o) => (
            <div key={o.id} data-testid={`order-${o.id}`} className="tv-glass rounded-xl p-4">
              <div className="flex items-center justify-between mb-2">
                <div>
                  <code className="text-white/60 text-xs">#{o.id.slice(0, 8)}</code>
                  <span className={`ml-2 text-[10px] uppercase font-bold px-2 py-0.5 rounded ${o.status === "paid" ? "bg-green-500/20 text-green-300" : "bg-yellow-500/20 text-yellow-300"}`}>{o.status}</span>
                </div>
                <div className="text-tv-accent font-bold">${o.subtotal.toFixed(2)}</div>
              </div>
              <div className="flex flex-wrap gap-2">
                {o.items.slice(0, 5).map((it) => (
                  <div key={it.product_id} className="flex items-center gap-2 text-xs text-white/80">
                    {it.image && <img src={it.image} alt="" className="w-10 h-10 rounded object-cover" />}
                    <span>{it.title} ×{it.qty}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
